var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9994 40.2968L37.6828 46.1534C39.4561 47.2268 41.6261 45.6401 41.1594 43.6334L38.5928 32.6201L47.1561 25.2001C48.7194 23.8468 47.8794 21.2801 45.8261 21.1168L34.5561 20.1601L30.1461 9.75344C29.3528 7.86344 26.6461 7.86344 25.8528 9.75344L21.4428 20.1368L10.1728 21.0934C8.11944 21.2568 7.27944 23.8234 8.84277 25.1768L17.4061 32.5968L14.8394 43.6101C14.3728 45.6168 16.5428 47.2034 18.3161 46.1301L27.9994 40.2968Z",
    fill: "#082567"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundStar);
export default __webpack_public_path__ + "static/media/round-star.6303a036dd4f416ed70c74036c95d895.svg";
export { ForwardRef as ReactComponent };